import _axios from '@/plugins/axios'
import { Cadastro } from 'common/types/Cadastro'
import Credenciais, { InputAssociarEmail, InputLoginCim, InputLoginFirebase, InputRevalidarPalavra } from 'common/types/Credenciais'
import Login from 'common/types/Login'

/** login anônimo do visitante, pela palavra semestral */
export async function logar(credenciais: Credenciais) {
	return _axios.post<Login>(`/auth/login`, credenciais)
}

export async function logarPeloCim(input: InputLoginCim) {
	return _axios.post<Login>(`/auth/login-cim`, input)
}

/** troca o ID token de um login feito direto no Firebase (e-mail e senha) pelo token do app */
export async function loginFirebase(input: InputLoginFirebase) {
	return _axios.post<Login>(`/auth/login-firebase`, input)
}

/** associa o e-mail de quem entrou pelo CIM e envia o link de confirmação */
export async function associarEmail(input: InputAssociarEmail) {
	return _axios.post<Login>(`/auth/associar-email`, input)
}

export async function aceitarTermosDeUso() {
	const { data } = await _axios.post<Login>(`/auth/aceitar-termos`)
	return data;
}

export async function recusarTermosDeUso() {
	await _axios.post<Login>(`/auth/recusar-termos`)
}

export async function revalidarPalavra(credenciais: InputRevalidarPalavra) {
	return _axios.post<Login>(`/auth/revalidar-palavra`, credenciais)
}

export async function registrar(input: Cadastro) {
	return _axios.post<Login>(`/auth/register`, input)
}

export async function logout() {
	return _axios.get(`/auth/logout`)
}
